export default {
      id: "close_big-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "sprite.svg#close_big",
      toString: function () {
        return this.url;
      }
    }